const styles = theme => ({
  dataContainer: {
    '& $accordion:last-of-type': {
      borderBottom: '0 !important',
    },
  },
  accordion: {
    borderBottom: `1px solid ${theme.palette.primary.borderColor} !important`,
    margin: '0 !important',
    boxShadow: 'none',
    '&::before': {
      display: 'none',
    },
  },
  accordionSummary: {
    padding: '10px 16px !important',
    '& .MuiAccordionSummary-content': {
      margin: '0 !important',
      alignItems: 'center',
    },
  },
  accordingSummaryImage: {
    '& .MuiAccordionSummary-content': {
      display: 'flex',
      gap: '14px',
    },
  },

  accordionDetails: {
    padding: '0px 64px 10px 16px !important',
  },
  paginationContainer: {
    borderTop: `1px solid ${theme.palette.primary.borderColor} !important`,
    padding: '8px 12px',
  },
  '@media (min-width: 768px)': {
    accordionSummary: {
      padding: '16px 24px !important',
    },
    accordionDetails: {
      padding: '0px 72px 16px 24px !important',
    },
    paginationContainer: {
      padding: '12px 18px !important',
    },
  },
  '@media (max-width: 767px)': {
    dataContainer: {
      '& h6, & p': {
        fontSize: '12px',
      },
    },
  },
});
export default styles;
